module.exports = __webpack_public_path__ + "website/img/yoyo13.b81abd8f.jpg";